import React, {memo} from 'react';

import {useSelector} from 'react-redux';

import Portal from '@/components/portal/Portal';
import {ModalMode} from '@/constants/modalEnum';
import {getMainRootModal} from '@/selectors/modalSelector';

import ModalRoot from '../modal/ModalRoot';

function MainModal() {
  const {mode} = useSelector(getMainRootModal);
  const modeList = {
    [ModalMode.DEFAULT]: ModalRoot,
  };
  const Content = modeList[mode];

  if (!Content) return null;

  return (
    <Portal id="root-modal">
      <Content />
    </Portal>
  );
}

export default memo(MainModal);
